import { Directive, computed, input } from '@angular/core';

/**
 * Adds support for readonly to radio groups
 *
 * @example
 * <fieldset readonlyRadioGroup>
 *   <label>
 *     <input type="radio" name="radio" value="1">
 *     Option 1
 *   </label>
 * </fieldset>
 */
@Directive({
  selector: 'fieldset[appReadonlyRadioGroup]',
  host: {
    '[attr.aria-disabled]': 'ariaDisabled()',
    '[attr.aria-labelledby]': 'ariaLabelledBy()',
    '(click)': 'onClick($event)',
    '(keydown)': 'onKeydown($event)',
  },
})
export class ReadonlyRadioDirective {
  appReadonlyRadioGroup = input(false);

  ariaDisabled = computed(() => (this.appReadonlyRadioGroup() ? 'true' : 'false'));
  ariaLabelledBy = computed(() => (this.appReadonlyRadioGroup() ? 'readonly-help' : null));

  onClick(event: MouseEvent) {
    if (this.appReadonlyRadioGroup()) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  onKeydown(event: KeyboardEvent) {
    if (this.appReadonlyRadioGroup() && event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
